<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%" >
      <v-flex lg12 pa-5 >
        <v-layout v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1"/>

        <v-layout wrap justify-center v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <div @click="mostrarPopupPromociones()" >
            <v-autocomplete
              v-model="promoSelected" id="promoSelected"
              :no-data-text="$t('sinDatos')"
              :items="promocionesConDatos"
              :label="localization.create.promocion"
              item-value="id"
              item-text="promocionesSeleccionadasDesc"
              readonly
              multiple
              >
            </v-autocomplete>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-autocomplete
              v-model="oficioSelected" id="oficioSelected"
              :no-data-text="$t('sinDatos')"
              :items="itemsOficios"
              :item-text="getItemText"
              item-value="id"
              :label="localization.create.oficio"
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  x-medium
                  close
                  @click:close="removeOficioSelected(data.item, 'colors')"
                  v-if="data.item.id !== 0"
                >
                  {{ mostrarIdioma(data.item) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-autocomplete
              :no-data-text="$t('sinDatos')"
              v-model="proveedorSelected" id="proveedorSelected"
              :items="proveedores"
              item-text="keyProvider"
              item-value="id"
              :label="localization.create.proveedor"
            />
          </v-flex>
          <v-flex v-if="!relationSelectedId" mb-2>
            <v-btn
              color="primary" right
              @click="checkRelationsProvidersByProffesion()"
              :disabled="!Boolean(promoSelected.length) || !Boolean(oficioSelected.length) || !Boolean(proveedorSelected.length)"
            >
              {{localization.create.guardar}}
            </v-btn>
          </v-flex>
          <v-flex v-else mb-2>
            <v-btn
              color="primary" right
              @click="editarProveedorPorOfiYpromo()"
              :disabled="!Boolean(promoSelected.length) || !Boolean(oficioSelected.length) || !Boolean(proveedorSelected.length)"
            >
              {{localization.create.editar}}
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout>
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.list.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle"></v-divider>
        <v-flex md8 mt-2 mb-5>
          <v-text-field v-model="search" id="search" prepend-icon="search" single-line hide-details
            @click:prepend="submitSearch(search)" @keyup.enter.native="submitSearch(search)"
          />
        </v-flex>
        <v-data-table
          :headers="headers"
          :items="proveedoresByProf"
          class="elevation-1"
          :loading="tableLoading"
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 20],
            'items-per-page-text': $t('filasPorPagina'),
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id" @click="selectItem(item)" :style="{'background-color': relationSelectedId === item.id ? 'lightgray' : ''}">
                <td class="text-xs-center">{{ item.propertyDevelopment }}</td>
                <td class="text-xs-center">{{ mostrarIdiomaOficio(item) }}</td>
                <td class="text-xs-center">{{ item.provider }}</td>
                <td class="text-xs-center">{{ item.email }}</td>
                <td class="text-xs-center" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
                  <v-flex row justify-center>
                    <!-- <v-icon class="iconSize" small @click="openDialog(item.id)">delete</v-icon> -->
                    <v-icon class="iconSize" small @click="comprobarUsado(item.providerId, item.professionId, item.id)">delete</v-icon>
                  </v-flex>
                </td>
              </tr>
            </tbody>
            <ConfirmDialog @close="deleteItem()" :text="textDialog"
              @cancel="dialog = false" :dialogFlag="dialog" 
              :textoTitulo="$t('eliminar')" :textoBoton="$t('eliminar')" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1"/>
          </template>
        </v-data-table>
      </v-flex>
      </v-card>
      <v-fade-transition>
      <custom-dialog
        v-if="mostrarSeleccionarPromociones"
        v-model="mostrarSeleccionarPromociones" id="mostrarSeleccionarPromociones"
      >
        <PopUpSeleccionarPromociones
          :multiple="true"
          @selected="promoSelected = $event"
        />
      </custom-dialog>
    </v-fade-transition>
    </v-layout>
    <v-fade-transition>
      <PopUpSeguro
        v-if="this.hasRelations === true"
        @aceptar="addProveedorPorOfiYpromo"
        :titulo="localization.registrosExistentes.title"
        :pregunta="localization.registrosExistentes.pregunta"
        :alerta="''"
        :descartar="localization.registrosExistentes.descartar"
        :cancelar="localization.registrosExistentes.aceptar"
        @volver="hasRelations = false"
        :volver="localization.registrosExistentes.cancelar"
        :mostrarVolver="true"
      />
    </v-fade-transition>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmDialog from '../../custom/confirmDialog'
import PopUpSeleccionarPromociones from './PopUpSeleccionarPromociones'
import PopUpSeguro from '@/components/generic/popups/PopUpSeguro'

export default {
  components: {
    ConfirmDialog,
    PopUpSeleccionarPromociones,
    PopUpSeguro
  },
  data () {
    return {
      textDialog: null,
      promoSelected: [],
      oficioSelected: [],
      proveedorSelected: [],
      dialog: false,
      mostrarSeleccionarPromociones: false,
      itemToDeleteId: null,
      codigo: null,
      nombreOficio: '',
      loader: null,
      relationSelectedId: null,
      tableLoading: false,
      search: null,
      checkMarcarDesmarcarOficios: false,
      hasRelations: false
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi'
    }),
    headers () {
      let usuario = JSON.parse(localStorage.getItem('usuario'))
      if ( usuario.restringirEdicionMaestros === true ) {
        return [
          { text: this.localization.list.promocion, width: '30%', value: 'propertyDevelopment', sortable: true, align: 'left' },
          { text: this.localization.list.oficio, width: '20%', value: 'profession', sortable: true, align: 'left' },
          { text: this.localization.list.proveedor, width: '30%', value: 'provider', sortable: true, align: 'left' },
          { text: this.localization.list.email, width: '15%', value: 'email', sortable: true, align: 'left' },
        ]
      }
      else {
        return [
          { text: this.localization.list.promocion, width: '30%', value: 'propertyDevelopment', sortable: true, align: 'left' },
          { text: this.localization.list.oficio, width: '20%', value: 'profession', sortable: true, align: 'left' },
          { text: this.localization.list.proveedor, width: '30%', value: 'provider', sortable: true, align: 'left' },
          { text: this.localization.list.email, width: '15%', value: 'email', sortable: true, align: 'left' },
          { text: this.localization.list.eliminar, width: '5%', value: '', align: 'center' }
        ]
      }
    },
    localization () {
      return this.$t('maestros.proveedoresPorOficio')
    },
    itemsOficios () {
      let oficios = []
      
      let oficioSeleccionarTodos = { id: 0, name: 'Seleccionar/Deseleccionar Todos',  translates: {spa: 'Seleccionar/Deseleccionar Todos', eng: 'Seleccionar/Deseleccionar Todos (eng)', eus: 'Hautatu/Deshautatu guztiak' } }
      oficios.push(oficioSeleccionarTodos)

      if (this.$store.state.incidencias.oficios) {
        this.$store.state.incidencias.oficios.forEach(oficio => {
          oficios.push(oficio)
        });
        return oficios
      }
      return []
    },
    oficios () {
      if (this.$store.state.incidencias.oficios) {
        return this.$store.state.incidencias.oficios
      }
      return []
    },
    translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones.map(x => {
            return {
              ...x,
              nombreCompleto: x.code + ' - ' + x.name
            }
          })

      }
      return []
    },
    proveedores() {
      if(this.promoSelected.length === 0 ) {
        if (this.$store.state.incidencias.providers) {
          return this.$store.state.incidencias.providers.map(x => {
            return {
              ...x,
              keyProvider: (x.code || '') + ' - ' + (x.name || '')
            }
          })
        }
        return []
      } else {
        
        if (this.$store.state.incidencias.providers) {
          // si solo hay una promo, comprobamos que los proveedores sean de esa sociedad
          let arrProveedores = this.$store.state.incidencias.providers;

          if(this.promoSelected.length === 1) {
            arrProveedores = arrProveedores.filter(item => {
              return item.idSociedad === this.promoSelected[0].idSociedad || this.promoSelected[0].idSociedad === null || item.idSociedad === null
            })
          }
          let proveedores = arrProveedores.map(x => {
            return {
              ...x,
              keyProvider: (x.code || '') + ' - ' + (x.name || '')
            }
          })
          if(this.idubapi.motor === 'SQLSERVER') {
            let promoSelected = this.promoSelected[0];
            let promocion = this.$store.state.incidencias.promociones.find(obj => obj.id === promoSelected.id)
            return proveedores.filter(obj => obj.idSociedad === promocion.idSociedad)
          } else {
            return proveedores
          }

        }
        return []
      }

    },
    proveedoresByProf () {
      if (this.$store.state.incidencias.providersByProf) {
        // return this.$store.state.incidencias.providersByProf
        return this.sortItemsByField(this.$store.state.incidencias.providersByProf,'propertyDevelopment')
      }
      return []
    },
    promocionesSeleccionadasConId () {
      return this.promoSelected.map(x => {
        return x.id
      })
    },
    promocionesConDatos () {
      return this.promoSelected.map(x => {
        return {
          ...x,
          id: x.id,
          promocionesSeleccionadasDesc: x.code + '-' + x.name
        }
      })
    }
  },
  mounted () {
    this.getOficios()
    this.getPromociones()
    this.getProviders()
    this.getProvidersByProffesion()
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getOficios: 'incidencias/getOficios',
      getPromociones: 'incidencias/getPropertiesDevelopment',
      getProviders: 'incidencias/getProviders',
      getProvidersByProffesion: 'incidencias/getProvidersByProffesion',
      addProviderByProffesion: 'incidencias/addProviderByProffesion',
      updateProviderByProffesion: 'incidencias/updateProviderByProffesion',
      checkUsado: 'incidencias/comprobarProviderByProffesionAsignado',
      delProviderByProffesion: 'incidencias/delProviderByProffesion',
      checkProvidersByProffesion: 'incidencias/checkProvidersByProffesion'
    }),
    getItemText(item) {
      if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0) {
        return item.translates[this.usuario.idioma];
      } else {
        return item.name || item.description || item.text || ''
      }
        
    },
    async comprobarUsado (providerId, professionId, id) {
      let response = await this.checkUsado({id: providerId, oficioId: professionId})
      if (response === 'KO') {

        const puedeBorrar = this.$store.state.configuracion.configuracion.PV_PERMITIR_BORRAR_MAESTROS_CON_INCI
        if(!puedeBorrar) {
          this.addAlert({texto: this.$t('no_puede_borrar_maestros'), color: 'error'})
          return
        }
        
        this.textDialog = this.$t('estaSeguroEliminarElementoTieneSolicitudes')
      } else {
        this.textDialog = this.$t('estaSeguroEliminarElemento')
      }
      this.openDialog(id)
    },
    async submitSearch (searchString) {
      try {
        this.promoSelected = []
        this.oficioSelected = []
        this.proveedorSelected = []
        this.tableLoading = true
        await this.getProvidersByProffesion(searchString)
        this.tableLoading = false
        this.itemSelected = []
      } catch (error) {
        this.tableLoading = false
        this.addAlert({texto: error, color: 'error'})
      }
    },
    selectItem (item) {
      if (!this.relationSelectedId || this.relationSelectedId !== item.id) {
        this.relationSelectedId = item.id
      } else {
        this.relationSelectedId = null
      }
    },
    async addProveedorPorOfiYpromo ( respuesta ) {
      this.hasRelations = false
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        // Eliminamos el elemento para seleccionar y deseleccionar todos
        if (this.oficioSelected.indexOf(0) !== -1) {
          let position =  this.oficioSelected.indexOf(0)
          this.oficioSelected.splice(position, 1)
        }
        const newItem = {
          proffesion: this.oficioSelected,
          propertyDevelopment: this.promocionesSeleccionadasConId,
          provider: this.proveedorSelected,
          sobreescribirRegistros: respuesta
        }
        await this.addProviderByProffesion(newItem)
        this.promoSelected = []
        this.oficioSelected = []
        this.proveedorSelected = []
        await this.getProvidersByProffesion()
        this.loader.hide()
        this.addAlert({texto: this.$t('alta_correcta'), color: 'success'})
      } catch (error) {
        this.loader.hide()
        this.addAlert({ texto: error.message , color: 'error' })
      }
    },
    async checkRelationsProvidersByProffesion () {
      const newItem = {
          proffesion: this.oficioSelected,
          propertyDevelopment: this.promocionesSeleccionadasConId,
          provider: this.proveedorSelected
        }
        this.hasRelations = await this.checkProvidersByProffesion(newItem)

        if ( this.hasRelations === false ) {
          //Si no tiene relaciones, llamamos al método para insertar las relaciones con el parámetro sobreescribir a false
          this.addProveedorPorOfiYpromo (false)
        }
    },
    async editarProveedorPorOfiYpromo () {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })

      if ( this.oficioSelected.length > 1 ) {
        this.loader.hide()
        this.addAlert({ texto: "Para la edición no puede seleccionar más de un oficio" , color: 'error' })
      }
      else if ( this.promocionesSeleccionadasConId.length > 1) {
        this.loader.hide()
        this.addAlert({ texto: "Para la edición no puede seleccionar más de una promoción" , color: 'error' })
      }
      else {
         try {
           // Eliminamos el elemento para seleccionar y deseleccionar todos
          if (this.oficioSelected.indexOf(0) !== -1) {
            let position =  this.oficioSelected.indexOf(0)
            this.oficioSelected.splice(position, 1)
          }

          const newItem = {
            id: this.relationSelectedId,
            proffesion: this.oficioSelected[0],
            propertyDevelopment: this.promocionesSeleccionadasConId[0],
            provider: this.proveedorSelected
          }
          await this.updateProviderByProffesion(newItem)
          this.relationSelectedId = null
          await this.getProvidersByProffesion()
          this.loader.hide()
          this.addAlert({texto: this.$t('alta_correcta'), color: 'success'})
        } catch (error) {
          this.loader.hide()
          this.addAlert({ texto: error.message , color: 'error' })
        }
      }
    },
    openDialog (itemId) {
      this.dialog = true
      this.itemToDeleteId = itemId
    },
    deleteItem () {
      this.delProviderByProffesion(this.itemToDeleteId)
        .then(() => {
          this.getProvidersByProffesion()
          this.addAlert({texto: this.$t('baja_correcta'), color: 'success'})
        })
        .catch(e => {
          return e
        })
      this.dialog = false
    },
    pintarPromocion(item) {
      let datosPromocion = item.item
      return (this.idubapi.motor === 'SQLSERVER') ? datosPromocion.name + ' - ' + datosPromocion.code : datosPromocion.code + ' - ' + datosPromocion.name
    },
    mostrarPopupPromociones () {
      if ( this.mostrarSeleccionarPromociones === false ) {
        this.mostrarSeleccionarPromociones = true
      }
      else {
        this.mostrarSeleccionarPromociones = false
      }
    },
    marcarDesmarcarOficios () {
      if ( this.checkMarcarDesmarcarOficios === true ) {
        this.oficioSelected = []
        this.oficios.forEach(oficio => {
          this.oficioSelected.push(oficio)
        });
      } else {
        this.oficioSelected = []
      }
    },
    removeOficioSelected (oficio) {
      var i = this.oficioSelected.indexOf( oficio.id );

      if ( i !== -1 ) {
          this.oficioSelected.splice( i, 1 );
      }
    },
    mostrarIdioma (item) {
      if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0 ) {
        return item.translates[this.usuario.idioma];
      } else {
        return item.name || item.description || item.text || ''
      }
    },
    mostrarIdiomaOficio (item) {
      let professionTranslates = (typeof item.professionTranslates === 'object') ? item.professionTranslates : JSON.parse(item.professionTranslates)
      if (professionTranslates && professionTranslates[this.usuario.idioma] && professionTranslates[this.usuario.idioma].length > 0 ) {
        return professionTranslates[this.usuario.idioma];
      } else {
        return item.profession
      }
    },
    sortItemsByField(items, field){
     let lista = [...items]

      return lista.sort(function (a, b) {
        if(a === null || typeof a[field] === "undefined" || a[field] === null){
          return 1
        }
        if(b === null || typeof b[field] === "undefined" || b[field] === null){
          return -1
        }
        let x = a[field].trim().toLowerCase()
        let y = b[field].trim().toLowerCase()
        if (x > y) {
          return 1
        }
        if (x < y) {
          return -1
        }
        return 0
      });
    }
  },
  watch: {
    relationSelectedId () {
      if (this.relationSelectedId != null) {
        let relation = this.proveedoresByProf.find(x => x.id === this.relationSelectedId)
        if ( relation ) {
          this.promoSelected = []
          this.oficioSelected = []
          this.proveedorSelected = []
          this.oficioSelected.push(relation.professionId)
          this.proveedorSelected = relation.providerId
          this.promoSelected.push ( this.promociones.find( promo => promo.id === relation.propertyDevelopmentId ) )
        }
        else {
          this.promoSelected = []
          this.oficioSelected = []
          this.proveedorSelected = []
        }
      } else {
        this.promoSelected = []
        this.oficioSelected = []
        this.proveedorSelected = []
      }
    },
    oficioSelected (newSelectedArray, oldSelectedArray) {
      let diferencia = []
      diferencia = newSelectedArray.filter(elemento => oldSelectedArray.indexOf(elemento) == -1)
      if ( diferencia.length === 0 ) {
        diferencia = oldSelectedArray.filter(elemento => newSelectedArray.indexOf(elemento) == -1)
      }

      if ( diferencia.length === 1 && diferencia[0] === 0) {
        if ( this.oficioSelected.indexOf(0) !== -1 ) {
            this.oficioSelected = []
            this.itemsOficios.forEach(oficio => {
              this.oficioSelected.push( oficio.id )
            });
        }
        else if ( diferencia.length === 1 && diferencia[0] === 0 ) {
          this.oficioSelected = []
        }
      }
      else if ( ( diferencia.length === 1 && diferencia[0] != 0)) {
        var i = newSelectedArray.indexOf( 0 );

        if ( i !== -1 ) {
            newSelectedArray.splice( i, 1 );
        }
        this.oficioSelected = []
        this.oficioSelected = newSelectedArray
      }
    }
  }
}
</script>
